// extracted by mini-css-extract-plugin
export default {"wallet":"wallet_wallet__vyvOi"};